export const classroomParticipantDtoFields = [{
        name: "name",
        title: "Name",
        render: (record) => record.lastName + " " + record.firstName
    }];
